export default "__VITE_ASSET__DkV_soBq__"